module.exports = __webpack_public_path__ + "static/media/SarahSwitek_01_Introduction_3.f8c6a0d3.mp3";